/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 19.02.15.
 */
angular.module('farmnet.partner.externalAccounts').factory('externalAccounts', [
  '$q',
  'ExternalAccountsHttp',
  'ExternalAccount',
  function ExternalAccountsFactory($q, ExternalAccountsHttp, ExternalAccount) {
    function ExternalAccounts() {
      var accounts = [];
      var allPromise = null;

      /**
       * Retrieves all accounts for this company.
       * @returns {ng.Promise} with result of type {Array<farmnet.partner.externalAccounts.ExternalAccount>}
       */
      this.all = function() {
        allPromise = ExternalAccountsHttp.all().then(function(result) {
          // clear
          while (accounts.length > 0) {
            accounts.pop();
          }

          result.data.forEach(function(account) {
            account = new ExternalAccount(account);
            accounts.push(account);
          });

          return accounts;
        });

        return allPromise;
      };

      /**
       * Updates an account and returns the updated account from server.
       * @param {farmnet.partner.externalAccounts.ExternalAccount}account
       * @returns {ng.Promise} with result of type {farmnet.partner.externalAccounts.ExternalAccount}
       */
      this.update = function(account) {
        return ExternalAccountsHttp.setCredentials(
          account.key,
          account.credentials
        ).then(function(result) {
          var updatedAccount = new ExternalAccount(result.data);

          // replace old account with updated account
          for (var i = 0; i < accounts.length; i++) {
            var ac = accounts[i];
            if (ac.id === updatedAccount.id) {
              angular.extend(ac, updatedAccount);
              break;
            }
          }

          return updatedAccount;
        });
      };

      /**
       * Checks if the credentials for the given account are valid.
       * @param {farmnet.partner.externalAccounts.ExternalAccount} account
       * @returns {ng.Promise} with boolean result
       */
      this.checkCredentials = function(account) {
        return ExternalAccountsHttp.checkCredentials(
          account.key,
          account.credentials
        ).then(function(result) {
          return result.data;
        });
      };

      /**
       * Checks if the account with the given key has credentials set.
       * @param {string} key
       * @returns {ng.Promise} with boolean result
       */
      this.hasCredentials = function(key) {
        return ExternalAccountsHttp.hasCredentials(key).then(function(result) {
          return result.data;
        });
      };

      /**
       * Returns true (in the promise) if the company hat at least an
       * account for the given group and the required services are bought.
       * @param {string} group
       * @returns {ng.Promise} with boolean result
       */
      this.hasAccountsInGroup = function(group) {
        if (allPromise === null) {
          this.all();
        }

        return allPromise.then(function(accounts) {
          for (var i = 0; i < accounts.length; i++) {
            var account = accounts[i];

            if (account.group === group && account.requiredServiceExists()) {
              return true;
            }
          }

          return false;
        });
      };
    }

    return new ExternalAccounts();
  }
]);
